export const PERMIT_KINDS = ['dig', 'traffic', 'utility', 'other'] as const
export const PERMIT_STATUSES = ['requested', 'granted', 'refused'] as const
export const CLAIM_KINDS = ['hindrance', 'change'] as const
export const CAUSES = ['client', 'permit', 'utility', 'weather', 'material', 'design', 'ground', 'other'] as const
export const DAMAGE_KINDS = ['power', 'gas', 'water', 'telecom', 'sewer', 'heating', 'property', 'complaint', 'other'] as const
export const CAUSED_BY = ['own_crew', 'sub', 'third_party', 'unknown'] as const
export const DAMAGE_STATUSES = ['open', 'repaired', 'claimed', 'closed'] as const

export type PermitKind = typeof PERMIT_KINDS[number]
export type PermitState = 'requested' | 'refused' | 'granted' | 'expiring' | 'expired' | 'pending'
export type ClaimKind = typeof CLAIM_KINDS[number]
export type ClaimStatus = 'draft' | 'notified' | 'accepted' | 'rejected' | 'paid' | 'withdrawn'

export interface PermitView {
  id: string; kind: PermitKind; authority: string; reference: string | null; area: string | null; status: typeof PERMIT_STATUSES[number]; state: PermitState
  requestedOn: string | null; grantedOn: string | null; validFrom: string | null; validTo: string | null; auInvoiceId: string | null; note: string | null
  byName: string | null; updatedAt: string
}
export interface ClaimView {
  id: string; kind: ClaimKind; number: number; label: string; title: string; description: string | null; cause: typeof CAUSES[number]
  occurredOn: string; endedOn: string | null; notifiedOn: string | null; status: ClaimStatus; amountClaimed: number | null; amountAgreed: number | null
  blockId: string | null; sessionIds: string[]; scanIds: string[]; warning: 'late' | 'overdue' | null; next: ClaimStatus[]; byName: string | null; updatedAt: string
}
export interface DamageView {
  id: string; occurredOn: string; kind: typeof DAMAGE_KINDS[number]; owner: string | null; location: string | null; description: string
  causedBy: typeof CAUSED_BY[number]; sessionId: string | null; reportedOn: string | null; status: typeof DAMAGE_STATUSES[number]
  costEstimate: number | null; insurance: boolean; byName: string | null; daysOpen: number | null
}
export interface AuPermitFee { invoiceId: string; authority: string; reference: string | null; kind: PermitKind; issuedOn: string | null; amount: number }
export interface AuDamage { recordId: string; occurredOn: string | null; street: string | null; city: string | null; description: string | null; damagedParty: string | null }
export interface ProjectRegisters {
  projectId: string; permits: PermitView[]; claims: ClaimView[]; damages: DamageView[]; auPermitFees: AuPermitFee[]; auDamages: AuDamage[]
  workedWithoutPermit: { days: number; first: string | null; last: string | null; registerFrom: string | null }
  extraWorkBilled: number
  me: { canPermits: boolean; canDraftClaims: boolean; canDecideClaims: boolean; canDamage: boolean }
}
export interface EvidenceDay {
  sessionId: string; workDate: string; crew: string | null; streets: string | null; comment: string | null; reports: number; rtkSegments: number
  scans: { id: string; capturedOn: string | null; lengthM: number; depthAvgM: number | null }[]
  auFiles: { kind: 'daily_report' | 'site_photo'; url: string; comment: string | null }[] | null
}
export interface RegisterAlert { projectId: string; projectName: string | null; kind: 'permit_expiring' | 'permit_expired' | 'notice_overdue' | 'damage_open'; label: string; date: string | null }
